import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import commonFunction from './assets/js/common.js';
//阿里云oss
import OSS from 'ali-oss';
// 引入antd
import Antd from './antd-ui';

// 引入axios
import axios from './axios';

import httpRequest from 'axios';
//MD5
import MD5 from 'MD5';

// 引入vuescroll
// import vuescroll from 'vuescroll';
import vuescroll from 'vuescroll/dist/vuescroll-native';
//引入moment
import moment from 'moment';

import VueAwesomeSwiper from 'vue-awesome-swiper';
// import style
import 'swiper/css/swiper.css';
Vue.use(VueAwesomeSwiper /* { default options with global component } */);

// router拦截器
router.beforeEach((to, from, next) => {
  if (to.path.toLowerCase().indexOf('main') > -1) {
    // 判断该路由是否需要登录权限
    let token = window.localStorage.getItem('token');
    let role_id = 0;
    if (window.localStorage.getItem('siteinfo')) {
      role_id = JSON.parse(window.localStorage.getItem('siteinfo')).role_id;
    }
    if (token != '' && token != null) {
      // 通过vuex state获取当前的token是否存在
      let localTime = Date.parse(new Date()) / 1000;
      let tokenArr = token.split('-');
      // console.log(parseInt(tokenArr[1]),localTime)
      if (localTime > parseInt(tokenArr[1]) + 14400) {
        next({
          // path: '/login',
          path: 'https://uc.cn3x.com.cn/index.php/login/index',
          query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      } else if (localTime > parseInt(tokenArr[1]) + 300) {
        httpRequest.post('/oauth/refreshtoken', { token: token }).then(res => {
          if (res.data.state == 200) {
            window.localStorage.setItem('token', res.data.data.token);
          }
          next();
        });
      } else {
        next();
      }
      if (to.meta.requireAuth) {
        if (role_id !== '1' && role_id !== '2') {
          next({ path: '/login' });
        }
      }
    } else {
      next({
        // path: '/login',
        path: 'https://uc.cn3x.com.cn/index.php/login/index',
        query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    next();
  }
});

Vue.config.productionTip = false;

// 引入拖拽组件

import 'font-awesome/css/font-awesome.min.css';
import VueHtml5Editor from 'vue-html5-editor';
import M from 'minimatch';
const options = {
  // 全局组件名称，使用new VueHtml5Editor(options)时该选项无效
  // global component name
  name: 'vue-html5-editor',
  // 是否显示模块名称，开启的话会在工具栏的图标后台直接显示名称
  // if set true,will append module name to toolbar after icon
  showModuleName: true,
  // 自定义各个图标的class，默认使用的是font-awesome提供的图标
  // custom icon class of built-in modules,default using font-awesome
  icons: {
    text: 'fa fa-pencil',
    color: 'fa fa-paint-brush',
    font: 'fa fa-font',
    align: 'fa fa-align-justify',
    list: 'fa fa-list',
    link: 'fa fa-chain',
    unlink: 'fa fa-chain-broken',
    tabulation: 'fa fa-table',
    image: 'fa fa-file-image-o',
    hr: 'fa fa-minus',
    eraser: 'fa fa-eraser',
    undo: 'fa-undo fa',
    'full-screen': 'fa fa-arrows-alt',
    info: 'fa fa-info'
  },
  // 配置图片模块
  // config image module
  image: {
    // 文件最大体积，单位字节  max file size
    sizeLimit: 20480 * 1024,
    // 上传参数,默认把图片转为base64而不上传
    // upload config,default null and convert image to base64
    upload: {
      url: 'https://api.ycrmt.cn/api/AliyunOss/Imgesupload',
      headers: {
        Authorization: window.localStorage.getItem('token')
      },
      params: {
        blob_num: 1,
        total_blob_num: 1,
        file_name: new Date().getTime() + '.jpg'
      },
      fieldName: 'file'
    },
    // 压缩参数,默认使用localResizeIMG进行压缩,设置为null禁止压缩
    // compression config,default resize image by localResizeIMG (https://github.com/think2011/localResizeIMG)
    // set null to disable compression
    compress: null,
    // 响应数据处理,最终返回图片链接
    // handle response data，return image url
    uploadHandler(responseText) {
      // default accept json data like  {ok:false,msg:'unexpected'} or {ok:true,data:'image url'}
      var json = JSON.parse(responseText);
      if (json.url) {
        return json.url;
      } else {
        alert(json.message);
      }
    }
  },
  // 语言，内建的有英文（en-us）和中文（zh-cn）
  // default en-us, en-us and zh-cn are built-in
  language: 'zh-cn',
  // 自定义语言
  i18n: {
    // specify your language here
    'zh-cn': {
      align: '对齐方式',
      image: '图片',
      list: '列表',
      link: '链接',
      unlink: '去除链接',
      table: '表格',
      font: '文字',
      'full screen': '全屏',
      text: '排版',
      eraser: '格式清除',
      info: '关于',
      color: '颜色',
      'please enter a url': '请输入网络地址',
      'create link': '创建链接',
      bold: '加粗',
      italic: '倾斜',
      underline: '下划线',
      'strike through': '删除线',
      subscript: '上标',
      superscript: '下标',
      heading: '标题',
      'font name': '字体',
      'font size': '文字大小',
      'left justify': '左对齐',
      'center justify': '居中',
      'right justify': '右对齐',
      'ordered list': '有序列表',
      'unordered list': '无序列表',
      'fore color': '前景色',
      'background color': '背景色',
      'row count': '行数',
      'column count': '列数',
      save: '确定',
      upload: '本地上传',
      progress: '进度',
      unknown: '未知',
      'please wait': '请稍等',
      error: '错误',
      abort: '中断',
      reset: '重置'
    }
  },
  // 隐藏不想要显示出来的模块
  // the modules you don't want
  hiddenModules: [],
  // 自定义要显示的模块，并控制顺序
  // keep only the modules you want and customize the order.
  // can be used with hiddenModules together
  visibleModules: [
    'font',
    'color',
    'text',
    'align',
    'list',
    'tabulation',
    'image',
    'eraser',
    'undo',
    'full-screen',
    'link',
    'unlink',
    'hr'
  ],
  // 扩展模块，具体可以参考examples或查看源码
  // extended modules
  modules: {
    // omit,reference to source code of build-in modules
  }
};

Vue.config.productionTip = false;

Vue.prototype.$commonFunction = commonFunction;
Vue.prototype.$md5 = MD5;
Vue.prototype.$moment = moment;
Vue.use(Antd);
Vue.use(VueHtml5Editor, options);
Vue.prototype.$OSS = OSS;
// 你可以在这里设置vueScroll的全局配置
Vue.use(vuescroll, {
  mode: 'native',
  // sizeStrategy: 'number',
  initialScrollY: false,
  initialScrollX: false,
  scrollingX: false,
  scrollingY: true,
  detectResize: false,
  zooming: true,
  name: 'myScroll' // 在这里自定义组件名字，默认是vueScroll
});

new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount('#app');
